export default class Scroll {
  constructor(element) {
    this.element = element
  }

  listen(callback) {
    this.callback = callback

    if (this.element) {
      this.element.addEventListener('scroll', this.onChange)
    } else {
      window.addEventListener('scroll', this.onChange)
    }
  }

  unlisten() {
    this.callback = null

    if (this.element) {
      this.element.removeEventListener('scroll', this.onChange)
    } else {
      window.removeEventListener('scroll', this.onChange)
    }

    this.element = null
  }

  getValue() {
    return this.element ? this.element.scrollTop : window.scrollY
  }

  onChange = () => {
    this.callback(this.getValue())
  }

  isScrollOnTop() {
    return this.getValue() <= 5
  }
}
